function pushToDataLayer(eventName, additionalData = {}) {
  const eventData = {
    event: eventName,
    ...additionalData,
  };
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(eventData);
}

document.addEventListener("DOMContentLoaded", function () {
  // Cookies consent data
  document.addEventListener('click', (event) => {
    if (event.target.closest('#shopify-pc__prefs__header-save')) {
      const coockiePopupWrapper = event.target.closest('#shopify-pc__prefs__dialog');
      const analyticsInput = coockiePopupWrapper.querySelector('#shopify-pc__prefs__analytics-input');
      const marketingInput = coockiePopupWrapper.querySelector('#shopify-pc__prefs__marketing-input');

      // Check if the checkboxes are checked and set the result to "granted" or "denied"
      const analytics_granted = analyticsInput.checked ? 'granted' : 'denied';
      const ad_granted = marketingInput.checked ? 'granted' : 'denied';
      sendData(analytics_granted,ad_granted)
    }
    if (event.target.closest('#shopify-pc__prefs__header-decline') || event.target.closest('#shopify-pc__banner__btn-decline')) {
      sendData('denied','denied');
    }
    if (event.target.closest('#shopify-pc__prefs__header-accept') || event.target.closest('#shopify-pc__banner__btn-accept')) {
      sendData('granted','granted');
    }
  })
  function sendData(analytics_granted,ad_granted) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'shopify_clarity_consent_update',
      clarity_analytics_storage: analytics_granted,
      clarity_ad_storage: ad_granted
    });
  }

});
